import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelperService } from 'src/app/core/services/helper.service';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { Subscription, timer } from 'rxjs';


import * as moment from 'moment';
import { checkCBSEGr8, isUserAdmin } from '@app-helpers/functions';
import { environment } from '@app-environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '@app-services/user/user.service';
import { SubscribemodalComponent } from '../subscribemodal/subscribemodal.component';
import { SubscribeActiveComponent } from '../subscribe-active/subscribe-active.component';

@Component({
  selector: 'app-course-class-list-card',
  templateUrl: './course-class-list-card.component.html',
  styleUrls: ['./course-class-list-card.component.css']
})
export class CourseClassListCardComponent implements OnInit, OnChanges {
  public omsdevapi = environment.omsdevapi;
  public LIVE_CLASS_API = environment.LIVE_CLASS_API;
  expandMobSubjctStatus: boolean = false;
  detailinfoStatus: boolean = false;
  weekAccroListStatus: boolean = false;
  mobfilterstatus: boolean = false;
  selectedTabIndex: number = 0;
  @Input() type: any;
  @Input() classData: any;
  @Input() dataType: any;
  @Input() courseInfo:any
  @Input() classInfo:any;
  private viewerDialog: any = null;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();
  isToday = false;
  isTomorrow = false;
  intervalSub:Subscription;
  public errImgTry: number = 0;
  public errImgMaxTry: number = 5;
  isDropup = true;
  isLive = false;
  set: any = '';
  videoId: any;
  cronjob: any;
  public classStatusSubscription : Subscription;
  showScience: boolean = false;
  omsPackageInfo: any;
  omsRespObj = {
    oms_userdto_course: null,
    isSubExpired: null,
    isExpiredByDate: null,
  };
  componentInstance: any;
  tempcourse: any;
  oms_userdto_course: any;
  wasAttendedByStd: boolean=false;
  mySubscriptionList: any;
  userData: any;
  prodBranch = environment.branch;
  isRecordedCourseClass: string;
  isUserLoggedInAsAdmin: boolean=false;
  constructor(private dialog: MatDialog, public _helper: HelperService,public _eventHandlingService :EventHandlingService,private spinner: NgxSpinnerService,
    private http: HttpClient,
    public modalservice: NgbModal,
    public userService:UserService) {
      this.isRecordedCourseClass = localStorage.getItem('isRecordedCourseFromCourseInfo')
      if(this.isRecordedCourseClass){
        this.classData = this.classInfo
      }
    this._eventHandlingService.getChangeClassStatus().subscribe((item: any) => {
      if(item){
        this.statusCheck();
      }
    })
  }

  ngOnInit(): void {   
    this.statusCheck();
    // this.checkingTimeOnInterval();
    this.checkStatus();
    this.showScience = checkCBSEGr8();
    this.userData = this.userService.getMobileAndName();
    this.checkteacherNotEndedClass(this.classData);
   }

  ngOnChanges(_changes: SimpleChanges): void {
  }

  previewDocument = async (_item: any) => {
    const config: MatDialogConfig = {
      data: {
        item: _item,
        isDocuments: true,
        isDownloadable: true,
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: 'doc-viewer-popup',
    };
    await isUserAdmin(this.userService).then(res=>this.isUserLoggedInAsAdmin =res?  true:false).catch(err=>this.isUserLoggedInAsAdmin = false)
    if(!this.isUserLoggedInAsAdmin && (this.classData?.subscription =="paid" || this.courseInfo?.courseCommercial =="paid")){
      if(!this.classData?.isRecordedClass){
      this.http.get(`${this.LIVE_CLASS_API}students/rewatchAccess?class=${this.classData?.id}&student=${this.userData?.userId}`).subscribe(res=>{
        if(JSON.parse(JSON.stringify(res)).data){
          this.wasAttendedByStd = true;
        }else{
          this.wasAttendedByStd = false;
        }
      })
    }else{
      this.wasAttendedByStd = false;
    }
    this.http
    .get(
      `${this.omsdevapi}userorders/mySubscription?grade=${this.userData.grade}&userId=${this.userData?.userId}`
    )
    .subscribe((resp) => {
      let omsresponse: any = resp;
      this.tempcourse = !this.classData.isRecordedClass ? this.classData?.course._id : this.classData?.course;
      if (omsresponse) {
        this.omsPackageInfo = omsresponse.map(
          (pack) =>  {
            if(!this.classData.isRecordedClass){
              this.mySubscriptionList =  pack?.mySubcriptionDtoList.filter(subcourse=> this.tempcourse ==subcourse?.userOrderPackageSubscriptionsDto?.courseId)
            }else{
              this.mySubscriptionList =  pack?.mySubcriptionDtoList.filter(subcourse=> subcourse?.userOrderPackageSubscriptionsDto?.recordedCourseList.some(val=>val.courseId ==this.tempcourse))
            }
            if(this.mySubscriptionList.length==1){                     
              this.mySubscriptionList.forEach(pack=>this.omsRespObj.isSubExpired = pack?.userOrderPackageSubscriptionsDto?.expired)
            }
            return this.mySubscriptionList
          }     
        )
        this.omsPackageInfo = this.omsPackageInfo?.filter(validPack=>validPack.length>0)
      }
      if (this.omsPackageInfo?.length > 0) {
        if(!this.classData.isRecordedClass){
          this.oms_userdto_course =
          this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.courseId
        }else{
          this.oms_userdto_course = this.courseInfo.id
        }
        // let courseExpireDate = moment(
        //   new Date(
        //     this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.expiryDate
        //   )
        // ).unix();
        // this.omsRespObj.isExpiredByDate =
        //   courseExpireDate > moment().unix() ? false : true;        
        let courseExpireDates =  this.omsPackageInfo?.flat()?.map(v=> moment(
          new Date(
            v?.userOrderPackageSubscriptionsDto?.expiryDate
          )
        ).unix())
        this.omsRespObj.isExpiredByDate =  courseExpireDates.map(v=>v> moment().unix() ? false : true).every(v=>v)
      }
      if (!this.oms_userdto_course) {
        this.callModal(config)
      } else if (
        this.tempcourse?.toString() ===
        this.oms_userdto_course?.toString() &&
          !this.omsRespObj.isSubExpired
          ) {
            if (!this.omsRespObj.isExpiredByDate) {  
              this.callModal(config)
            }  else {
              this.componentInstance = this.modalservice.open(
                SubscribemodalComponent,
                {
                  centered: true,
                  size: 'sm',
                windowClass: 'subscription-modal-custom',
              }
              );
              this.spinner.hide(); 
               
            }
          } else {
            if(this.omsRespObj.isExpiredByDate){
              this.componentInstance = this.modalservice.open(SubscribemodalComponent,{
                centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
              })
              this.spinner.hide();          
            }else{
              this.componentInstance = this.modalservice.open( SubscribeActiveComponent,{
                centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
              })
              this.spinner.hide();
              return
            }
            }
          });
        } else { 
          this.callModal(config)
        }
      
   
  };

  openCourseCurriculum = (_item: any) => {
    
    const config: MatDialogConfig = {
      data: _item.src,
      disableClose: false,
      scrollStrategy: new NoopScrollStrategy(),
    };
    const dialogRef = this.dialog.open(PdfViewerComponent, config);
    dialogRef.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    });
  };

  
  statusCheck() {
    if (this.dataType == 'course') {
      if(!this.courseInfo?.isRecordedCourse){
      this.type = UtilityService.classType(
        this.classData.serverTime,
        this.classData?.obj?.startTime,
        this.classData?.obj?.endTime,
        this.classData?.obj?.meetingStatus
      );
      }else{
        this.type ='past'
      }
    }
    if(!this.courseInfo?.isRecordedCourse){
    this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
    if (!this.isToday) {
      this.isTomorrow = UtilityService.isTomorrow(
        this.classData.schedule.startDate,
        this.classData.schedule.serverTime
      );
    }
    }
  }

  expandMobSubjctBtn(){
    this.expandMobSubjctStatus = !this.expandMobSubjctStatus;
  }
  detailBtnAction(){
    this.detailinfoStatus = !this.detailinfoStatus;
  }
  weekAccroBtnAction(){
    this.weekAccroListStatus = !this.weekAccroListStatus;
  }
  mobfilterbtnAction() {
    this.mobfilterstatus = !this.mobfilterstatus;
  }
  ngOnDestroy(){
    if(this.classStatusSubscription){
      this.classStatusSubscription?.unsubscribe();
    }


  }

  checkStatus(){
    if(!this.courseInfo?.isRecordedCourse){
    if(this.dataType != 'past'){
      this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      if(this.isToday){
       this.cronjob = UtilityService.liveClassCounter( this.classData.serverTime , this.classData?.obj?.startTime, this.classData?.obj?.endTime)
       let liveat:any;

       if(this.cronjob?.ediff >= 0){
        liveat =  setTimeout(() => {
          this.isLive = true;
          if (this.classData?.meeting?.status != 'ended') {
            this.type = 'ongoing';
          }
          }, this.cronjob?.sdiff-300000);

           let  livetill = setTimeout(() => {
            this.isLive =  false;
            window.location.reload();
            this._eventHandlingService.classEndCheck.next(this.classData);
            this._eventHandlingService.changeClassStatus('endClass');
            clearTimeout(livetill);
            clearTimeout(liveat);
         }, this.cronjob?.ediff);
        //liveat =  setTimeout(() => {
        //   this.isLive = true;
        //    }, this.classData?.classtype?.replace(' ','')?.toLowerCase() === 'courseclass' ? (this.cronjob?.sdiff-300000) : this.cronjob?.sdiff);
        //    let  livetill = setTimeout(() => {
        //      if (this.classData?.meeting?.status === 'ended') {
        //       this.isLive =  false;
        //       this._eventHandlingService.changeClassStatus('endClass');
        //       clearTimeout(livetill);
        //       clearTimeout(liveat);
        //      }
        //  }, this.cronjob?.ediff);

        //   } else if(this.cronjob?.sdiff <= 0 && this.cronjob?.ediff >= 0){
        //     this.isLive =  true;
        //   } else if(this.cronjob?.ediff == 0) {
        //     this.isLive =  false;

        }
      }else {
        this.statusCheck()
      }
    }
    }


  }

  callModal(config: MatDialogConfig<any>) {
    this.viewerDialog = this.dialog.open(DocumentViewerComponent, config);

    this.viewerDialog.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    this.viewerDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    });
  }
  ngOnDestoy(){
    
    if(this.isRecordedCourseClass){
      localStorage.removeItem('isRecordedCourseFromCourseInfo')
      localStorage.removeItem('pages')
      localStorage.removeItem('page')
    }
  }
  checkteacherNotEndedClass(classData) {
    if (classData?.meeting?.status === 'started') {
      this.isLive = true;
    }
  }
}
